import React from 'react';
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  translate as t,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import EditButton from '../components/button/EditButton';
import DeleteButton from '../components/button/DeleteButton';
import TranslatableInput from '../components/inputs/TranslatableInput';
import TranslatableField from '../components/fields/TranslatableField';

export const AllergenList = (props) => (
  <List {...props}>
    <Datagrid>
      <TranslatableField source="title" />
      <EditButton {...props} basePath="/allergens" />
      <DeleteButton {...props} basePath="/allergens" />
    </Datagrid>
  </List>
);

const AllergenTitle = t(({ record, translate }) => (
  <span>{record ? translate('edit.title', { title: record.name }) : ''}</span>
));

export const AllergenEdit = t((props) => (
  <Edit title={<AllergenTitle />} {...props}>
    <SimpleForm>
      <TranslatableInput source="title" />
      <ReferenceInput {...props} source="parent" label={props.translate('resources.allergens.fields.mainAllergen')} reference="allergens" allowEmpty>
        <SelectInput
          optionText="name"
          optionValue="_id"
        />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
));

export const AllergenCreate = t((props) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
      <TranslatableInput source="title" />
      <ReferenceInput {...props} source="parent" label={props.translate('resources.allergens.fields.mainAllergen')} reference="allergens" allowEmpty>
        <SelectInput
          optionText="name"
          optionValue="_id"
        />
      </ReferenceInput>
    </SimpleForm>
  </Create>
));
